import React, { useState, useEffect, useRef } from "react";

const CustomDatePicker = ({
  value,
  onChange,
  placeholder = "Select date",
  className = "",
}) => {
  const [dd, setDd] = useState("");
  const [mm, setMm] = useState("");
  const [yyyy, setYyyy] = useState("");
  const lastEmittedRef = useRef("");
  const mmRef = useRef(null);
  const yyyyRef = useRef(null);

  useEffect(() => {
    if (value) {
      const parts = value.split("-");
      if (parts.length === 3) {
        setYyyy(parts[0]);
        setMm(parts[1]);
        setDd(parts[2]);
        lastEmittedRef.current = value;
      }
    }
  }, [value]);

  const emitChange = (day, month, year) => {
    if (day && month && year && year.length === 4) {
      const dateStr = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      const date = new Date(dateStr);
      if (!isNaN(date.getTime()) && lastEmittedRef.current !== dateStr) {
        lastEmittedRef.current = dateStr;
        onChange && onChange(dateStr);
      }
    } else {
      if (lastEmittedRef.current !== "") {
        lastEmittedRef.current = "";
        onChange && onChange("");
      }
    }
  };

  const handleDdChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 2);
    setDd(val);
    emitChange(val, mm, yyyy);
    if (val.length === 2) mmRef.current?.focus();
  };

  const handleMmChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 2);
    setMm(val);
    emitChange(dd, val, yyyy);
    if (val.length === 2) yyyyRef.current?.focus();
  };

  const handleYyyyChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 4);
    setYyyy(val);
    emitChange(dd, mm, val);
  };

  const inputStyle = {
    border: "none",
    outline: "none",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 500,
    background: "transparent",
    color: dd || mm || yyyy ? "#262626" : "#bfbfbf",
  };

  return (
    <div
      className={`flex items-center border border-gray-300 rounded-lg bg-white ${className}`}
      style={{ padding: "12px" }}
    >
      {placeholder && <label className="sr-only">{placeholder}</label>}
      <input
        type="text"
        inputMode="numeric"
        placeholder="DD"
        value={dd}
        onChange={handleDdChange}
        maxLength={2}
        style={{ ...inputStyle, width: "40px" }}
        aria-label="Day"
      />
      <span style={{ fontSize: "18px", color: "#999", fontWeight: 500 }}>
        /
      </span>
      <input
        ref={mmRef}
        type="text"
        inputMode="numeric"
        placeholder="MM"
        value={mm}
        onChange={handleMmChange}
        maxLength={2}
        style={{ ...inputStyle, width: "40px" }}
        aria-label="Month"
      />
      <span style={{ fontSize: "18px", color: "#999", fontWeight: 500 }}>
        /
      </span>
      <input
        ref={yyyyRef}
        type="text"
        inputMode="numeric"
        placeholder="YYYY"
        value={yyyy}
        onChange={handleYyyyChange}
        maxLength={4}
        style={{ ...inputStyle, width: "60px" }}
        aria-label="Year"
      />
    </div>
  );
};

export default CustomDatePicker;
